import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './index.css';
import { safeLocalStorage, safeSessionStorage } from './utils/storage';

// Early Telegram WebApp Initialization — Dismiss native splash screen as fast as possible
(function ensureTelegramReady(attempts = 0) {
  try {
    if (typeof window !== 'undefined' && window.Telegram?.WebApp) {
      window.Telegram.WebApp.ready();
      window.Telegram.WebApp.expand();
    } else if (typeof window !== 'undefined' && attempts < 50) {
      setTimeout(() => ensureTelegramReady(attempts + 1), 50);
    }
  } catch (e) {
    console.warn('[startup] Failed early Telegram SDK initialization:', e);
  }
})();

// Programmatic IndexedDB & localStorage reset via query parameter
(async () => {
  try {
    if (typeof window !== 'undefined' && window.location.search.includes('reset=true')) {
      if (typeof window.indexedDB !== 'undefined' && typeof window.indexedDB.databases === 'function') {
        try {
          const dbs = await window.indexedDB.databases();
          for (const db of dbs) {
            if (db?.name) {
              window.indexedDB.deleteDatabase(db.name);
            }
          }
        } catch (idbErr) {
          console.warn('[startup] IndexedDB database list unavailable:', idbErr);
        }
      }
      try {
        safeLocalStorage.clear();
        safeSessionStorage.clear();
      } catch (storageErr) {
        console.warn('[startup] Storage clear failed:', storageErr);
      }
      
      const url = new URL(window.location.href);
      url.searchParams.delete('reset');
      window.location.replace(url.pathname + url.search);
    }
  } catch (err) {
    console.error('[startup] Failed to clear database:', err);
  }
})();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('[startup] Root element #root not found in DOM');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
